import { z } from "zod/v4";

import { ExperimentWithIdSchema } from "../../../../dtos/deprecated/experiments";

import { PluginProductConfigSchema_2023_08_20 } from "./testProducts/2023-08-20";
import { PluginTestGroupSchema } from "./testGroups";
import { PluginTrafficConfigSchema_2023_08_20 } from "./trafficConfig";

export * from "./testGroups";
export * from "./trafficConfig";

export const PluginExperimentSchema_2023_08_20 = ExperimentWithIdSchema.extend({
  testGroups: PluginTestGroupSchema.array(),
  testProducts: PluginProductConfigSchema_2023_08_20.array(),
  trafficConfig: PluginTrafficConfigSchema_2023_08_20.nullish(),
  measurementId: z.string().optional(),
}).omit({
  description: true,
  randomSeed: true,
  startedAtTs: true,
  createdAtTs: true,
  endedAtTs: true,
  analysisUrl: true,
  progress: true,
  controlGroup: true,
  analyticsViewType: true,
  excludeFromImpact: true,
  impact: true,
  controlMonthly: true,
  impactMetric: true,
  containsProductErrors: true,
  devicePreview: true,
});
export type PluginExperimentType_2023_08_20 = z.infer<
  typeof PluginExperimentSchema_2023_08_20
>;
